module.exports = __webpack_public_path__ + "img/steps1.bca9a000.svg";